import { type i18n, initI18n } from '@ayeldo/frontend-core/i18n/i18n';

import idpEn from './locales/en/idp.json';
import idpSv from './locales/sv/idp.json';

export function initIdpI18n(): typeof i18n {
  const instance = initI18n();

  instance.addResourceBundle('en', 'idp', idpEn, true, false);
  instance.addResourceBundle('sv', 'idp', idpSv, true, false);

  const idpNamespaces = ['idp'];
  const currentNs = instance.options.ns as string[];
  for (const ns of idpNamespaces) {
    if (!currentNs.includes(ns)) {
      currentNs.push(ns);
    }
  }

  return instance;
}
